'use strict';

exports.__esModule = true;
exports['default'] = endsWith;

/**
 * Check if a string ends with something
 * @private
 */
function endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}

module.exports = exports.default;
